import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import { renderTime } from '@nile/projects/src/Utils';
import { BoxContainer, SrcInfoContainer } from '@nile/banyan/src/Utils/style';
import {
  DeleteModal,
  getTranslatedText,
  AccessControl,
  CascadeCard,
  BackgroundIcon
} from '@nile/components';
import {
  Button,
  ButtonGroup,
  Heading,
  ResourceItem,
  ResourceList,
  TextStyle,
  Avatar
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import dompurify from 'dompurify';
import React, { Component } from 'react';
import styled from 'styled-components';

import { FormattedMessage, injectIntl } from 'react-intl';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const TaskTemplateDisplay = (props) => {
  const { intl } = props;
  const { estimatedTime, technician, techGroup } = props.taskTemplate;
  return (
    <div className="mt-20">
      <Heading element="h2">
        <FormattedMessage id="admin.taskTemplate.config.header" />
      </Heading>

      <div className="ml-10">
        <div className="fx mt10 w70 space-between">
          <div>
            <div className="mt10">
              <TextStyle variation="subdued" weight="Medium">
                <FormattedMessage id="admin.taskTemplate.config.techgroup" />
              </TextStyle>
            </div>
            <div className="mt10 val flex actr">
              <div className="mr-10 fx center" style={{ opacity: '0.6' }}>
                <SVGIcon name="TechnicianGroup" />
              </div>
              {techGroup ? (
                <TextStyle weight="Bold">{techGroup?.name}</TextStyle>
              ) : (
                <TextStyle variation="subdued">
                  <FormattedMessage id="app.noData.message" />
                </TextStyle>
              )}
            </div>
          </div>
          <div>
            <div className="mt10">
              <TextStyle variation="subdued" weight="Medium">
                <FormattedMessage id="admin.taskTemplate.config.tech" />
              </TextStyle>
            </div>
            <div className="mt10 val flex actr">
              <div className="mr-10">
                <Avatar customer name="Owner" size="extraSmall" />
              </div>
              {technician ? (
                <TextStyle weight="Bold">
                  {`${technician?.firstName} ${technician?.lastName}`}
                </TextStyle>
              ) : (
                <TextStyle variation="subdued">
                  <FormattedMessage id="app.noData.message" />
                </TextStyle>
              )}
            </div>
          </div>
        </div>
        <div className="fx mt10 w70 space-between">
          <div>
            <div className="mt10">
              <TextStyle variation="subdued" weight="Medium">
                <FormattedMessage id="admin.taskTemplate.config.estTime" />
              </TextStyle>
            </div>
            <div className="mt10 val flex actr">
              <div className="mr-10 fx center" style={{ opacity: '0.6' }}>
                <SVGIcon name="EstimatedTime" />
              </div>
              {renderTime(estimatedTime) ? (
                <TextStyle weight="Bold">{renderTime(estimatedTime)}</TextStyle>
              ) : (
                <TextStyle variation="subdued" weight="Bold">
                  <FormattedMessage id="app.noData.message" />
                </TextStyle>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class TaskCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      templates: props.data ? props.data : [],
      selectedItems:
        props.data.length > 0 ? [props.data[0].taskTemplateId] : [],
      selectedTemplate: null,
      uioptions: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (JSON.stringify(props?.data) !== JSON.stringify(state?.templates)) {
      return {
        ...state,
        templates: props.data,
        selectedItems:
          props.data.length > 0 ? [props.data[0].taskTemplateId] : [],
        selectedTemplate: props.data.length > 0 ? props.data[0] : null
      };
    }
    return null;
  }

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
      const { templates } = this.state;
      const item = templates.find((item) => {
        return item.taskTemplateId === selectedItem[selectedItem.length - 1];
      });
      this.renderSubItem(item);
    }
  };

  renderSubItem = (item) => {
    this.setState({ selectedTemplate: item });
  };

  componentDidMount() {
    if (this.props.data.length > 0) {
      this.renderSubItem(this.props.data[0]);
    }
  }

  deleteTaskTemplate = (id) => {
    this.props.deleteTaskTemplate({
      variables: { taskTemplateId: id }
    });
  };

  handleReplyChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.taskTemplateId] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { intl } = this.props;
    const { selectedTemplate, templates, selectedItems } = this.state;

    const processedAllItems = processData(templates, 'taskTemplateId');

    return (
      <div className="full-height">
        <BoxContainer className="fx full-height">
          <div className="fx fh full-width">
            <div className="fx no-scroll white-transparent-bg w30 border-right p20 fh">
              <div className="full-width fx col">
                <div className="sticky-search">
                  <AutoComplete
                    options={processedAllItems}
                    handleChange={this.handleReplyChange}
                  />
                </div>
                <div className="ch-50 f11 scroll py-10">
                  <ResourceList
                    items={templates}
                    selectedItems={selectedItems}
                    onSelectionChange={this.setSelectedItems}
                    renderItem={(item) => {
                      const { taskTemplateId, title } = item;
                      return (
                        <ResourceItem
                          id={taskTemplateId}
                          accessibilityLabel={`View details for ${title}`}
                        >
                          <div className="fw fx list-item">
                            <TextStyle variation="strong">{title} </TextStyle>
                            {item.uioptions && item.uioptions.length > 0 ? (
                              <div className="iconHolder">
                                <SVGIcon name="ArrowRight" />
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </ResourceItem>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            {selectedTemplate && (
              <div className="fx p2040 scroll w70 white-transparent-bg">
                <div className="full-width">
                  <div className="flex actr m-0">
                    <div className="fx2">
                      <Heading element="h2">{selectedTemplate?.title}</Heading>
                    </div>
                    <div
                      superid="rtOuterActions"
                      className="Reply-Templates-Actions"
                    >
                      <ButtonGroup>
                        <AccessControl
                          roleToCheck="taskTemplate.delete"
                          render={
                            <DeleteModal
                              description={getTranslatedText(
                                intl,
                                'admin.taskTemplate.delete.confirm'
                              )}
                              id="deleteTemplateBtn"
                              handleDeleteConfirmation={() =>
                                this.deleteTaskTemplate(
                                  selectedTemplate.taskTemplateId
                                )
                              }
                              title={getTranslatedText(
                                intl,
                                'admin.taskTemplate.delete.text'
                              )}
                            />
                          }
                        />
                        <AccessControl
                          roleToCheck="taskTemplate.edit"
                          render={
                            <Button
                              secondary
                              icon={<SVGIcon name="Edit" />}
                              url={
                                '#/onboard/tasktemplate/' +
                                selectedTemplate.taskTemplateId +
                                '/edit'
                              }
                            />
                          }
                        />
                      </ButtonGroup>
                    </div>
                  </div>
                  <div className="template-content pt10 pb10 ch-40 scroll">
                    <div className="fx mt10 ws-prewrap">
                      <TextStyle variation="subdued">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: dompurifier(selectedTemplate?.description)
                          }}
                        />
                      </TextStyle>
                    </div>
                    <TaskTemplateDisplay
                      intl={intl}
                      taskTemplate={selectedTemplate}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </BoxContainer>
      </div>
    );
  }
}

export default injectIntl(TaskCascade);
